<template>
  <div class="right-menu-item choseLang">
    <el-dropdown trigger="click" @command="handleSetLang">
      <div class="choseLangBox">
        <el-image
          :src="require('@/assets/image/language.svg')"
          alt=""
          slot="reference"
        ></el-image>
        <span class="langu">{{ title }}</span>
      </div>
      <el-dropdown-menu slot="dropdown" class="langDrop">
        <el-dropdown-item
          v-for="(item, index) in langList"
          :key="index"
          :command="item.languageCode"
          >{{ item.languageName }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { loadLanguageAsync, } from "@/lang/i18n";
import { queryEnabledLanguageCode, saveLocaleLanguageCode } from "@/api/user/index.js";
export default {
  data() {
    return {
      userLang: "",
      langList: this.$store.state.user.languageList || localStorage.getItem('languageList')
    };
  },
  created() {
    this.queryEnabledLanguageCode();
  },
  computed: {
    title() {
      let title = '';
      title = this.langList.length ? 
        this.langList.find((ele) => ele.languageCode === this.$i18n.locale)
        .languageCode.toUpperCase() : navigator.language || navigator.userLanguage;
      return title;
    },
  },
  methods: {
    queryEnabledLanguageCode() {
      queryEnabledLanguageCode()
        .then((res) => {
          this.langList = res;
          this.$store.commit("SET_LANGUAGELIST", this.langList);
          this.userLang = "";
          if (localStorage.getItem("lang")) {
            this.userLang = localStorage.getItem("lang");
          } else {
            this.userLang = navigator.language || navigator.userLanguage;
          }
          this.userLang = this.userLang.split("-").join("_");
          saveLocaleLanguageCode({
            locale: this.userLang
          }).then(() => {}).catch(() => {});
          let flagI = this.langList.findIndex(
            (el) => el.languageCode === this.userLang
          );
          if (flagI >= 0) {
            localStorage.setItem("lang", this.userLang);
            loadLanguageAsync(this.userLang);
          } else {
            localStorage.setItem("lang", "en_GB");
            loadLanguageAsync("en_GB");
          }
        })
        .catch(() => {});
    },
    handleSetLang(e) {
      this.$i18n.locale = e;
      localStorage.setItem("lang", e);
      saveLocaleLanguageCode({
        locale: e
      }).then(() => {
        loadLanguageAsync(e).then((res) => {
          location.reload();
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.langDrop {
  top: 6rem !important;
  width: 35rem;
  .el-dropdown-menu__item {
    width: 50%;
    display: inline-block;
    color: #00aa00;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.el-dropdown {
  width: 7rem;
  height: 2rem;
  text-align: center;
  cursor: pointer;
  color: #000;
  font-size: 1.4rem;
}
.choseLang {
  .choseLangBox {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-image {
      width: 2.5rem;
      height: 2.5rem;
    }
    .langu {
      vertical-align: middle;
      font-size: 1.4rem;
      color: #000;
      margin-top: 0.5rem;
    }
  }
  img {
    vertical-align: middle;
  }
}
</style>
